// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"6ad83b4f","706":"2069a5c8","891":"f70f4b28"}[chunkId] + ".css";
};